<template>
  <div id="Balken">
    <div v-for="u in uebungen" :key="u" class="outer">
      <div class="boxHolder">
        <div
          v-for="i in 10"
          :key="i"
          class="box"
          :class="[10 - i < height[u] ? 'achieved' : '']"
        ></div>
      </div>
      <div class="AtoD notranslate">{{ u }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Balken",
  components: {},
  props: {
    me: {
      type: Object,
      default: () => {},
    },
    uebungen: {
      type: Array,
      default: () => ["A", "B", "C", "D"],
    },
  },
  watch: {
    me: function () {
      this.generate();
    },
  },
  data() {
    return {
      height: {},
    };
  },

  methods: {
    generate() {
      let s = 0;
      let length = 0;
      for (const u in this.me) {
        if (u == "score" || u == "winner" || u == "nameAlt") continue;
        this.height[u] = 0;
        length = 0;
        s = 0;
        for (const f in this.me[u]) {
          //calculate sum
          s +=
            this.me[u][f].data.reduce((a, b) => a + b, 0) /
            (this.me[u][f].data.length * 10);
          length++;
        }
        if (length != 0) {
          s /= length;
        }
        this.height[u] = Math.round(s * 10);
        console.log(this.height);
      }
    },
    scoreFilter(n) {
      if (n == 0) return "--,-";
      let s = parseFloat(n).toLocaleString("de-DE");
      if (!String(s).includes(",")) {
        return s + ",0";
      }
      return s;
    },
  },
  created() {
    this.generate();
  },
};
</script>

<style scoped>
.boxHolder {
  /* background: linear-gradient(to bottom, #49ab5b 0%, #2b6536 100%); */
  background: linear-gradient(to bottom, #3db854 0%, #30703c 100%);
}

.AtoD {
  width: min(50px, 6.5vh);
  height: min(50px, 6.5vh);
  text-align: center;
  font-size: min(43px, 5vh);
  border-radius: 5px;
  margin: 5px;
  line-height: min(57px, 7vh);
  background: var(--green);
  color: white;
}

#Balken {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  position: absolute;
  left: 50%;
  top: 53%;
  transform: translate(-50%, -50%);
  width: min(100%, 650px);
}

.outer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}

.box {
  border: 1px solid var(--green);
  width: min(3.5vh, 40px);
  height: min(3.5vh, 40px);
  margin: 3px 0px;
  border-radius: 2px;
  box-shadow: 0px 0px 0px 3px white;
  background: white;
  aspect-ratio: 1;
}

.box:first-child {
  margin-top: 0px !important;
}

.box:last-child {
  margin-bottom: 0px !important;
}

.achieved {
  /* background: var(--green); */
  background: transparent !important;
}

@media screen and (max-height: 700px) and (max-width: 440px) {
  #Balken {
    margin-top: 0px;
  }
}

@media screen and (max-height: 640px) and (max-width: 440px) {
  #Balken {
    margin-top: 0px;
  }
}

/* @media screen and (max-height: 535px) and (max-width: 440px) {
  .box {
    width: 3.5vh;
  }
} */

@media screen and (max-height: 490px) and (max-width: 440px) {
  .box {
    width: 3vh;
  }

  .AtoD {
    width: 6vh;
    height: 6vh;
    line-height: 7vh;
  }
}
</style>
